import { useNuxtApp, useRequestEvent, useRuntimeConfig } from "nuxt/app";
import type { PublicDataCache } from "#shared/types/public-data-cache";

export function usePublicDataRequest(): PublicDataCache {
    const nuxtApp = useNuxtApp();
    const event = import.meta.server ? useRequestEvent() : undefined;
    const { medusaUrl, medusaToken, strapiUrl, strapiToken, searchUrl, searchApiKey } = useRuntimeConfig().public;
    const namespace = [medusaUrl, medusaToken, strapiUrl, strapiToken, searchUrl, searchApiKey];

    return (key, load, maxAge) => {
        if (!event?.context.publicDataCache || event.context.strapiPreview) return load();
        return event.context.publicDataCache(
            [namespace, key],
            () => nuxtApp.runWithContext(load),
            maxAge,
        );
    };
}
